import { Component, TemplateRef, ViewChild } from '@angular/core';
import { SpinnerComponent } from "../../layout/spinner/spinner.component";
import { LanguageService } from 'src/app/services/language/language.service';
import { ToastrService } from 'ngx-toastr';
import { PostsService } from 'src/app/services/posts/posts.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PageFormModalComponent } from "../pages/page-form-modal/page-form-modal.component";
import { PagesService } from 'src/app/services/pages/pages.service';
import { CatalogFormModalComponent } from "./catalog-form-modal/catalog-form-modal.component";
import { environment } from '../../../../environments/environment'
@Component({
  selector: 'app-posts',
  imports: [SpinnerComponent, CommonModule, FormsModule, PageFormModalComponent, CatalogFormModalComponent],
  templateUrl: './posts.component.html',
  styleUrl: './posts.component.css'
})
export class PostsComponent {

    data: any
    load = false
    loaddata = false
    currentLang = 'ge'
    loadDeleteId: number | null = null;

    pagination: any = null;
    page: number = 1;
    perPage: number = 20;

    selectedItems: any
    selectedItem: string = ''

    @ViewChild('scrollTarget') scrollTarget: any;


    selectedPost: any = null;
    @ViewChild('postFormModal') pageFormModalTemplate!: TemplateRef<any>;
    @ViewChild('postCatalogFormModal') postCatalogFormModal!: TemplateRef<any>;
    
    domain  = environment.apiDomain
    defaultDomain = environment.defaultDoamin

    search: string = '';

    sortColumn: string = '';
    sortDirection: 'asc' | 'desc' = 'asc';

    sortData(column: string) {
      if (this.sortColumn === column) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = column;
        this.sortDirection = 'asc';
      }

      if (this.data?.items) {
        this.data.items = [...this.data.items].sort((a, b) => {
          const valueA = a[column];
          const valueB = b[column];

          if (valueA == null) return 1;
          if (valueB == null) return -1;

          if (valueA < valueB) return this.sortDirection === 'asc' ? -1 : 1;
          if (valueA > valueB) return this.sortDirection === 'asc' ? 1 : -1;
          return 0;
        });
      }
    }

    constructor(
      private langService: LanguageService,
      private ToastrService: ToastrService,
      private PostsService: PostsService,
      private PagesService: PagesService,
      private modalService: NgbModal,
    ){
  
      this.currentLang = this.langService.getLanguage();
  
      this.langService.currentLanguage$.subscribe((lang) => {
        this.currentLang = lang;
          this.getPageItems()
          this.getPageByItems()
      });
  
      this.getPageItems()
      this.getPageByItems()
    }
  
    onPageChange(){
      this.getPageByItems()
    }

    get selectedMenuType(): number {
      const found = this.selectedItems.find((item: any) => item.slug === this.selectedItem);
      return found?.menutype ?? 0;
    }

    get selectedMenuSource(): string {
      const found  = this.selectedItems.find((item: any) => item.slug === this.selectedItem);
      return found?.source ?? '';
    }

  getPageItems(){
    this.load = true;
    this.PostsService.getPageItems().subscribe(
      (res: any) => {
        this.load = false;
        this.selectedItems = res;
        if (this.selectedItems && this.selectedItems.length > 0) {
          this.selectedItem = this.selectedItems[0].slug;  // პირველი ელემენტის slug-ს დავაყენებთ
          this.getPageByItems();  // აქვე დავუძახებთ getPageByItems-ს, რომ პირველი პოსტი აიტვირთოს
        } else {
          this.selectedItem = ''; // თუ სია ცარიელია, დავუშვათ ცარიელი სტრინგი
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
      },
      (error: any) => {
        console.log(error);
        this.load = false;
      }
    );
  }
  
    getPageByItems() {
      this.loaddata = true;

      const params = {
        lang: this.currentLang,
        type: this.selectedItem,
        page: this.page,
        perPage: this.perPage,
        q: this.search   
      };

      this.PostsService.getPageByItems(params).subscribe(
        (res: any) => {
          this.data = res;
          this.pagination = res.pagination;
          this.loaddata = false;
          console.log('data: ', this.data)
        },
        (error: any) => {
          // console.log(error);
          this.loaddata = false;
        }
      );
    }
  
    changePage(newPage: number) {
      this.page = newPage;
      this.getPageByItems();
      if (this.scrollTarget?.nativeElement) {
        this.scrollTarget.nativeElement.scrollIntoView({ behavior: 'smooth' });
      }
    }

    openPost(){
      this.selectedPost = null;
      if(this.selectedMenuSource == 'catalogs'){
        this.modalService.open(this.postCatalogFormModal, {size: 'lg'})
      }else {
        this.modalService.open(this.pageFormModalTemplate, { size: 'lg' });
      }
    }

    editPage(data: any){
      
      this.selectedPost = data;
      if(this.selectedMenuSource == 'catalogs'){
        this.modalService.open(this.postCatalogFormModal, {size: 'lg'})
      }else {
        this.modalService.open(this.pageFormModalTemplate, { size: 'lg' });
      }
    }

    onPostSaved() {
      // this.ToastrService.success('ცვლილება შენახულია წარმატებით');
      this.modalService.dismissAll(); // Close the modal if open
      this.getPageByItems() // Refresh list
      this.selectedPost = null;
    }

    onCloseModal() {
      this.modalService.dismissAll();
    }

    onCatalogSaved() {
      // this.ToastrService.success('ცვლილება შენახულია წარმატებით');
      this.modalService.dismissAll(); // Close the modal if open
      this.getPageByItems() // Refresh list
      this.selectedPost = null;
    }


    delete(data: any, source: string) {
      if (confirm(`დარწმუნებული ხარ რომ გინდა წაშლა: "${data.title}"?`)) {
        console.log(data)
        this.loadDeleteId = data.id;
        this.PostsService.delete(data.id, source).subscribe({
          next: () => {
            this.ToastrService.success('წარმატებით წაიშალა');
            this.getPageByItems();
            this.loadDeleteId = null;
          },
          error: (err: any) => {
            console.error(err);
            this.ToastrService.error('შეცდომა წაშლისას');
            this.loadDeleteId = null;
          }
        });
      }
    }


    // getFullImageUrl(imagePath: string): string {
    //   if (!imagePath) return '';

    //   // თუ უკვე სავსე URL-ია
    //   if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    //     // აქ შეგიძლია შეცვალო დომენი ან 그대로 დააბრუნო
    //     // თუ უნდა და შეცვალო დომენი, გააკეთე აქ ლოჯიკა
    //     // ან უბრალოდ დაუბრუნე ის რაც არის
    //     return imagePath.replace('https://ajaraheritage.ge', 'https://api.ajaraheritage.ge/storage');
    //   }

    //   // თუ რელატიური ბმულია, დაამატე შენს Base URL-ს წინ
    //   return `https://api.ajaraheritage.ge/storage/${imagePath.replace(/^\/+/, '')}`;
    // }

    // დროებითი
    getFullImageUrl(imagePath: string): string {
      if (!imagePath) return '';

      // დროებით არ ცვლის დომენს, უბრალოდ თუ სრული URL არის, 그대로 დააბრუნე
      if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
        return imagePath;
      }

      // თუ რელატიური ბმულია, დროებით დაუმატე არსებული დომენი (მაგ. აჯარა)
      return `${this.domain}${imagePath.replace(/^\/+/, '')}`;
    }


}
